import { Emoji } from './emoji';

export * from './emoji';

export default Emoji;
